module.exports = __webpack_public_path__ + "static/media/search-icon.33f3a313.svg";